@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/variables-dark";
@import "~bootstrap/scss/maps";
@import "~bootstrap/scss/mixins";

.entityIcon {
  --entity-icon-size: 75px;
  --entity-icon-avatar-size: 75px;
  --entity-icon-avatar-font-size: 36px;
  --entity-icon-card-body-height: 62px;
  --entity-icon-glyph-size: 42px;
  --entity-icon-overlap: -10px;
  --entity-icon-fill: var(--#{$prefix}secondary);
  --entity-circle-label-font-size: 12px;
}

.groupIcon {
  color: var(--#{$prefix}secondary);
  font-size: 24px;
  font-weight: bold;
}

.layout {
  background-color: var(--entity-icon-fill);
}

@include media-breakpoint-up(md) {
  .layout {
    background-color: transparent;
  }

  .entityBadge {
    background-color: var(--entity-icon-fill);
    color: var(--#{$prefix}white);
  }

  .glyph {
    font-size: var(--entity-icon-glyph-size);
  }

  .label {
    color: var(--entity-icon-fill);
    height: 26px;
  }

  .card {
    border: var(--#{$prefix}border-width) solid var(--#{$prefix}secondary);
    overflow: hidden;
    width: var(--entity-icon-size);

    .entityBadge {
      height: var(--entity-icon-card-body-height);
      width: 100%;
    }

    .label {
      text-align: center;
      width: 100%;
    }
  }

  .circle {
    .entityBadge {
      background-color: transparent;
      border: var(--#{$prefix}border-width) solid var(--#{$prefix}secondary);
      border-radius: 50%;
      color: var(--entity-icon-fill);
      height: var(--entity-icon-avatar-size);
      width: var(--entity-icon-avatar-size);
    }

    .label {
      background-color: var(--entity-icon-fill);
      color: var(--#{$prefix}white);
      border: var(--#{$prefix}border-width) solid var(--#{$prefix}border-color);
      margin-top: var(--entity-icon-overlap);
      font-size: var(--entity-circle-label-font-size);
    }

    .userAvatar {
      --size: var(--entity-icon-avatar-size);
      --font-size: var(--entity-icon-avatar-font-size);
    }
  }
}
